import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";
import "@/lib/pwa"; // capture the PWA install prompt as early as possible

// Opaque "Script error." events come from cross-origin third-party scripts
// (analytics beacons, browser extensions) and carry no file/line/stack — there
// is nothing in our code to act on, so keep them out of the error overlay.
window.addEventListener(
  "error",
  (e) => {
    if (e.message === "Script error." && !e.filename && !e.lineno) {
      e.stopImmediatePropagation();
      e.preventDefault();
    }
  },
  true,
);

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);

// Register the service worker so the app is installable (PWA) and the shell
// works offline. Registration failures are non-fatal — the site still runs.
if ("serviceWorker" in navigator) {
  window.addEventListener("load", () => {
    navigator.serviceWorker.register("/service-worker.js").catch(() => {});
  });
}
